/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { ADPResourceService } from 'digital-core';
import { isEmpty as _isEmpty } from 'lodash';
import { ValidateOtpResponseDtoV0 } from '../create-account.component';
import { AccountSignUpDtoV0 } from 'src/app/core/services/sign-up/account-signup.dto';

const USE_MOCK = false;

@Injectable({
  providedIn: 'root',
})
export class AccountServiceV0 {
  middlewareUrl: string;
  accountPath: string;
  isElita: string;
  companyCode: string;
  private dealerIds: string = null;

  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    public resourceService: ADPResourceService
  ) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
    this.isElita = this.resourceService.getPortalSetting('Global_CTC_IsElita').Value;
    this.dealerIds = this.resourceService.getPortalSetting("Global_DealerCodes").Value;
    this.companyCode = this.resourceService.getPortalSetting('Global_CTC_CompanyCode').Value;
  }

  accountLookup(email: string, token: string = undefined) {
    const oktaPrefix = this.preInitSettingsService.getSiteSettings().oktaPrefix;
    const body = {
      firstName: '',
      email: email,
      reCaptchaValue: token
    };
    return this.http.post(`${this.middlewareUrl}${this.accountPath}accountLookup-v0?isElitaActive=${this.isElita}&dealerIds=${encodeURIComponent(this.dealerIds)}&companyCode=${this.companyCode}&oktaPrefix=${oktaPrefix}`, body);
  }

  validateOTP(encryptedOtp: string, otpcode: string, email: string) {
    const body = {
      encryptedOtp: encryptedOtp,
      otpcode: otpcode,
      email: email
    };
    return this.http.post<ValidateOtpResponseDtoV0>(`${this.middlewareUrl}${this.accountPath}validateOTP-v0?&dealerIds=${encodeURIComponent(this.dealerIds)}&companyCode=${this.companyCode}`, body);
  }

  resendOTP(email: string, firstName: string, encryptedOtp: string) {
    const body = {
      firstName: firstName,
      email: email,
      encryptedOtp: encryptedOtp
    };
    return this.http.post(`${this.middlewareUrl}${this.accountPath}resendOTP-v0`, body);
  }

  public signUpNewAccount(signupInfo: AccountSignUpDtoV0) {
    return this.http.post<string>(`${this.middlewareUrl}${this.accountPath}account-signup`, signupInfo);
  }

}
